import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClimateChangeV2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 49,
	viewBox: "0 0 60 49",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1352_15334",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 21,
			y: 13,
			width: 39,
			height: 35,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M59.3514 48H23L21 42.5L23.5 37.5L23 32.5L21 27V13H59.3514V48Z",
				fill: "#256F94"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_1352_15334)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M59.8245 23.4053C55.4826 23.4053 55.4826 26.9904 51.1501 26.9904C46.8177 26.9904 46.8082 23.4053 42.4758 23.4053C38.1434 23.4053 38.1434 26.9904 33.8109 26.9904C29.4785 26.9904 29.4785 23.4053 25.1366 23.4053C20.7947 23.4053 20.8042 26.9904 16.4717 26.9904C12.1393 26.9904 12.1393 23.4053 7.80688 23.4053V32.9688C12.1393 32.9688 12.1393 36.5539 16.4717 36.5539C20.8042 36.5539 20.8042 32.9688 25.1366 32.9688C29.469 32.9688 29.469 36.5539 33.8109 36.5539C38.1528 36.5539 38.1434 32.9688 42.4758 32.9688C46.8082 32.9688 46.8177 36.5539 51.1501 36.5539C55.4826 36.5539 55.492 32.9688 59.8245 32.9688V23.4053Z",
					fill: "#F7DD97"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.48657 20.5674C8.819 20.5674 8.819 24.1525 13.1514 24.1525C17.4839 24.1525 17.4839 20.5674 21.8163 20.5674C26.1487 20.5674 26.1487 24.1525 30.4906 24.1525C34.8325 24.1525 34.8231 20.5674 39.1555 20.5674C43.4879 20.5674 43.4974 24.1525 47.8298 24.1525C52.1622 24.1525 52.1717 20.5674 56.5041 20.5674",
					stroke: "#256F94",
					strokeWidth: 2,
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.48657 30.1406C8.819 30.1406 8.819 33.7258 13.1514 33.7258C17.4839 33.7258 17.4839 30.1406 21.8163 30.1406C26.1487 30.1406 26.1487 33.7258 30.4906 33.7258C34.8325 33.7258 34.8231 30.1406 39.1555 30.1406C43.4879 30.1406 43.4974 33.7258 47.8298 33.7258C52.1622 33.7258 52.1717 30.1406 56.5041 30.1406",
					stroke: "#256F94",
					strokeWidth: 2,
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23 39.7041C27.3324 39.7041 27.3324 43.2892 31.6743 43.2892C36.0162 43.2892 36.0068 39.7041 40.3392 39.7041",
					stroke: "#256F94",
					strokeWidth: 2,
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.018 29.9991C21.8258 29.8102 21.7514 29.634 21.7514 29.3633C21.7576 22.9679 21.7514 16.5725 21.7514 10.177C21.7514 9.94413 21.7514 9.71122 21.7328 9.47832C21.5344 7.1241 20.3875 5.43082 18.2982 4.39849C17.7527 4.12782 17.1575 4.0334 16.5747 3.88232H15.1984C14.8388 3.98304 14.4792 4.05858 14.1259 4.17818C11.6398 5.02796 10.1085 7.23111 10.1085 9.96301C10.1085 16.3458 10.1023 22.7287 10.1147 29.1115C10.1147 29.5584 9.97832 29.848 9.66833 30.1627C7.31868 32.5232 6.38253 35.4062 7.08309 38.6669C7.89524 42.4374 10.2635 44.7979 13.9585 45.7673C14.2623 45.8491 14.597 45.7925 14.8698 45.9939H15.2728C15.3286 45.9436 15.3782 45.9436 15.434 45.9939H16.4073C16.4631 45.9436 16.5127 45.9436 16.5685 45.9939H16.8103C17.1885 45.824 17.6101 45.8554 18.0068 45.7421C21.5158 44.7727 23.8407 42.5318 24.7024 38.9438C25.5332 35.4817 24.5598 32.4603 22.0056 29.9928L22.018 29.9991ZM22.3094 37.6219C21.9932 40.3035 20.4867 42.1353 17.982 43.0543C14.2933 44.4076 10.0961 41.7953 9.58774 37.8611C9.25296 35.2677 10.1209 33.1716 12.173 31.5853C12.3714 31.428 12.4334 31.2706 12.4272 31.0314C12.421 27.9218 12.4272 22.2943 12.4272 19.1848C12.4272 16.0752 12.4272 13.167 12.4272 10.1581C12.4272 8.42081 13.3447 6.96673 15.0186 6.61423C18.0192 5.97846 19.5381 8.4334 19.4451 10.7121C19.4389 10.9387 19.3274 10.9324 19.1724 10.9324C18.2982 10.9324 17.4241 10.9324 16.5499 10.9324C16.2399 10.9324 15.9424 10.9765 15.7254 11.2345C15.4898 11.5115 15.4278 11.8325 15.5766 12.1662C15.7378 12.525 16.0478 12.6886 16.4259 12.6886C17.3249 12.6886 18.2238 12.7012 19.1228 12.6886C19.377 12.6886 19.4575 12.7453 19.439 13.0096C19.4142 13.3684 19.4142 13.7272 19.439 14.0797C19.4575 14.363 19.3894 14.4574 19.0856 14.4511C18.199 14.426 17.3125 14.4323 16.4259 14.4511C15.7378 14.4637 15.341 15.0114 15.5518 15.6094C15.682 15.9745 15.9734 16.1822 16.4321 16.1822C17.3311 16.1885 18.23 16.1948 19.129 16.1822C19.3584 16.1822 19.4513 16.2262 19.439 16.4843C19.4142 16.8809 19.4204 17.2712 19.439 17.6677C19.4513 17.8943 19.3832 17.9573 19.1538 17.9573C18.23 17.9447 17.3063 17.951 16.3825 17.9573C16.0106 17.9573 15.7254 18.1272 15.5704 18.4735C15.4216 18.8071 15.4836 19.1281 15.7192 19.4051C15.9362 19.6632 16.2399 19.7009 16.5499 19.7009C17.3745 19.7009 18.2052 19.7198 19.0298 19.6946C19.3646 19.682 19.4451 19.7765 19.4451 20.1164C19.4327 23.1378 19.4451 28.0477 19.4328 31.0692C19.4328 31.3209 19.5071 31.4657 19.7055 31.6168C21.6832 33.1275 22.5946 35.167 22.3094 37.6408V37.6219Z",
			fill: "#F7DD97"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6423 44.741C13.3695 44.5396 13.0347 44.5962 12.7309 44.5144C9.03596 43.545 6.6615 41.1845 5.85555 37.4139C5.15499 34.147 6.09114 31.2703 8.4408 28.9098C8.75078 28.5951 8.88717 28.3118 8.88717 27.8586C8.86857 21.4757 8.87477 15.0929 8.88097 8.71008C8.88097 5.97188 10.4185 3.77503 12.8983 2.92525C13.2517 2.80565 13.6113 2.72382 13.9709 2.62939H15.3472C15.9299 2.78047 16.5251 2.87489 17.0707 3.14556C19.16 4.17789 20.3131 5.87117 20.5053 8.22539C20.5239 8.45829 20.5239 8.6912 20.5239 8.9241C20.5239 15.3195 20.5239 21.7149 20.5239 28.1104C20.5239 28.3747 20.5983 28.5573 20.7905 28.7461C23.3385 31.2137 24.318 34.2351 23.4873 37.6972C22.6317 41.2852 20.3069 43.5261 16.7917 44.4955C16.3949 44.6025 15.9733 44.571 15.5952 44.7473H15.3534C15.2976 44.6969 15.248 44.6969 15.1922 44.7473H14.2188C14.1631 44.6969 14.1135 44.6969 14.0577 44.7473H13.6547L13.6423 44.741Z",
			stroke: "#256F94",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.3447 29.6339C23.4005 29.5269 23.4501 29.5458 23.5059 29.6339H23.3447Z",
			fill: "#256F94"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4792 29.6339C24.535 29.5458 24.5846 29.5269 24.6404 29.6339H24.4792Z",
			fill: "#256F94"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5438 41.1468C14.3987 41.4363 12.5512 40.1396 12.0738 38.0183C11.7205 36.432 12.3962 34.7765 13.8345 33.8197C14.1507 33.612 14.2561 33.398 14.2499 33.0266C14.2251 31.4151 14.2375 29.8037 14.2437 28.186C14.2437 27.2732 14.7769 26.5871 15.5828 26.4171C16.6554 26.1905 17.5977 26.9963 17.6101 28.1671C17.6163 29.0169 17.6101 29.8666 17.6101 30.7164C17.6101 31.5096 17.6287 32.3027 17.6039 33.0895C17.5915 33.4106 17.6783 33.5994 17.9573 33.7694C18.8376 34.317 19.4204 35.1038 19.718 36.1236C20.3689 38.3645 18.8128 40.832 16.5314 41.1405L16.5438 41.1468Z",
			fill: "#F7DD97"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3038 39.888C13.1587 40.1775 11.3112 38.8808 10.8339 36.7595C10.4805 35.1732 11.1562 33.5177 12.5946 32.5609C12.9107 32.3532 13.0161 32.1392 13.0099 31.7678C12.9851 30.1564 12.9975 28.5449 13.0037 26.9272C13.0037 26.0144 13.5369 25.3283 14.3428 25.1584C15.4154 24.9317 16.3577 25.7375 16.3701 26.9083C16.3763 27.7581 16.3701 28.6079 16.3701 29.4576C16.3701 30.2508 16.3887 31.0439 16.3639 31.8307C16.3515 32.1518 16.4383 32.3406 16.7173 32.5106C17.5977 33.0582 18.1804 33.8451 18.478 34.8648C19.129 37.1057 17.5729 39.5732 15.2914 39.8817L15.3038 39.888Z",
			stroke: "#256F94",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6899 11.8892H20.5176",
			stroke: "#256F94",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6899 15.666H20.5176",
			stroke: "#256F94",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6899 19.4429H20.5176",
			stroke: "#256F94",
			strokeWidth: 2,
			strokeLinejoin: "round"
		})
	]
});
export default SvgClimateChangeV2;
